import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.91058 4.41076C7.23602 4.08533 7.76366 4.08533 8.08909 4.41076L13.0891 9.41077C13.4145 9.7362 13.4145 10.2638 13.0891 10.5893L8.08909 15.5893C7.76366 15.9147 7.23602 15.9147 6.91058 15.5893C6.58514 15.2638 6.58514 14.7362 6.91058 14.4108L11.3213 10L6.91058 5.58928C6.58514 5.26384 6.58514 4.7362 6.91058 4.41076Z",
		fill: "url(#paint0_linear_next)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_next",
		x1: 13.1577,
		y1: -11.0897,
		x2: 5.98201,
		y2: -10.8914,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#616CE0" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#4B8DEA"
		})]
	}) })]
});
export default SvgChevronRight;
